// eslint-disable-next-line eag/match-named-export
export const WEBSOCKET_PROTOCOL = 'graphql-ws';
export const KEEP_ALIVE_TIMEOUT_FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
export const MAX_CACHE_SIZE = 50;
export const RECONNECT_BASE_DELAY_MS = 5_000;
export const RECONNECT_MAX_DELAY_MS = 60_000;
export const RECONNECT_BACKOFF_FACTOR = 2;
export const MAX_REAUTH_ATTEMPTS = 3;
export const NORMAL_CLOSE_CODE = 1000;
